import { ProcessingOrderBoxUploader } from "./processing/ProcessingOrderBoxUploader";
import { OrderIdentityVerification } from "src/contexts/documentationArea/domain/OrderIdentityVerification";
import { IdentityVerificationDocumentSides } from "src/contexts/identityVerification/domain/IdentityVerificationDocumentSides";
import { IDVIdleOrderBoxUploader } from "./idle/IDVIdleOrderBoxUploader";

interface OrderBoxUploaderProps {
  order: OrderIdentityVerification;
  side: IdentityVerificationDocumentSides;
  isDragOver?: boolean;
  onDragEnd?: () => void;
}

export const IDVOrderBoxUploader = ({
  order,
  side,
  isDragOver,
  onDragEnd,
}: OrderBoxUploaderProps) => {
  if (order.hasValidResponses()) return null;
  if (order.isSideLoading(side)) return <ProcessingOrderBoxUploader />;
  return (
    <IDVIdleOrderBoxUploader
      order={order}
      side={side}
      isDragOver={isDragOver}
      onDragEnd={onDragEnd}
    />
  );
};
